export default {"src":"/_next/static/media/solid-star.304790cd.svg","height":24,"width":26};